import {type SignOutParams, type SignOutResponse, signOut as nextAuthSignOut} from 'next-auth/react'

import {analytics} from '@/utils/tracking/analytics'

export const signOut = <R extends boolean = true>(
  options?: SignOutParams<R>,
): Promise<R extends true ? undefined : SignOutResponse> => {
  analytics.reset()
  return nextAuthSignOut(options)
}
